import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { BILLING_CATEGORY } from "./apiRoutes";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getBillingCategoryByCommunity = async (communityId: string) =>
  await axiosAuth.get(`${BILLING_CATEGORY}/community/${communityId}`);

const useGetBillingCategoryByCommunity = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["billing-categories", communityId],
    queryFn: () => getBillingCategoryByCommunity(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBillingCategoryByCommunity;
